"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ScrollableFlowScreen } from "../UI/ScrollableFlowScreen";
import { AgenticMemoryDemo } from "../Demos/AgenticMemoryDemo";
import Image from "next/image";

interface AgenticMemoryScrollSectionProps {
  onDownloadClick?: () => void;
}

export function AgenticMemoryScrollSection(_props: AgenticMemoryScrollSectionProps) {
  const agenticMemoryRef = useRef<HTMLDivElement>(null);

  // Use the demo container ref for text scroll progress to ensure perfect sync
  const { scrollYProgress } = useScroll({
    target: agenticMemoryRef,
    offset: ["start center", "end end"],
  });

  const texts = [
    "Agentic Memory securely learns from your browser history and notes to understand your context. Allowing you to instantly recall past information and get answers about your previous work just by asking—no more searching.",
  ];

  // 第二阶段"Still..." 文本显示 (0.7-1.0, 占总进度30%)
  const stillTextOpacity = useTransform(scrollYProgress, [0.7, 0.75, 0.9, 1.0], [0, 1, 1, 1]);

  return (
    <div>
      <ScrollableFlowScreen
        ref={agenticMemoryRef}
        onViewportEnter={() => console.log("Agentic Memory entered")}
        compact={true}
      >
        <div className="flex min-h-[400vh]">
          {/* Left Half - Text Effect Fixed on Screen */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <motion.div className="max-w-[600px] space-y-12">
              <h2 className="text-4xl font-bold text-white/90 mb-8 w-full">
                <div className="w-full">Agentic Memory </div> Learns You, Knows You
              </h2>
              {texts.map((text, index) => (
                <div key={index} className="text-2xl font-medium text-white/90 leading-relaxed">
                  {text}
                </div>
              ))}

              {/* Still Text - 第二阶段文本显示 (0.7-1.0) */}
              <motion.div className="space-y-8" style={{ opacity: stillTextOpacity }}>
                <div className="text-3xl font-bold text-white/90 leading-tight">
                  <div className="flex items-center gap-2 relative mb-4">Still manually feeding context to AI?</div>
                  <div className="flex items-center gap-2">
                    <div className="relative flex-shrink-0 size-8">
                      <Image
                        src="/favicon.ico"
                        alt="fellou"
                        fill
                        priority
                        unoptimized
                        className="rounded p-0.5 ring-1 ring-white/20"
                      />
                    </div>
                    <div>Fellou remembers everything.</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>

          {/* Right Half - Sticky Demo */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <AgenticMemoryDemo containerRef={agenticMemoryRef} />
          </div>
        </div>
      </ScrollableFlowScreen>
    </div>
  );
}
